import Image from 'next/image';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ServiceAnimation2 = () => {
  const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: true });

  return (
    <div ref={ref}>
      <div className="absolute h-[116.92px] top-[44px] left-[44px]">
        <Image
          src="/images/e-signature/api-box.svg"
          alt=""
          width={83.79}
          height={116.92}
          layout="fixed"
          priority={true}
        />

        <motion.div
          className="absolute top-0 w-full bg-[#182A3B]"
          initial={{ opacity: 1, height: '100%' }}
          animate={
            inView ? { opacity: 0, height: 0 } : { opacity: 1, height: '100%' }
          }
          transition={{ duration: 1, delay: 0.3 }}
        ></motion.div>
      </div>
      <motion.div
        className="absolute w-fit top-[3px] left-[40px]"
        initial={{ opacity: 0, scale: 0, top: 40, left: 35 }}
        animate={
          inView
            ? {
                opacity: 1,
                scale: [0, 1],
                top: 3,
                left: 40,
                transition: { type: 'spring', delay: 0.3, duration: 1 },
              }
            : { opacity: 0, scale: 1 }
        }
      >
        <div className="w-fit">
          <Image
            src="/images/e-signature/api-cloud.svg"
            alt=""
            width={111.75}
            height={93.56}
            layout="fixed"
          />
        </div>
        <motion.div
          className="absolute w-fit top-[34px] left-[21px]"
          initial={{ opacity: 1 }}
          animate={
            inView
              ? {
                  opacity: [0.9, 1, 0.9],
                  transition: { duration: 0.5, delay: 1.3, loop: Infinity },
                }
              : { opacity: 1 }
          }
          exit={{ opacity: 1 }}
        >
          <Image
            src="/images/e-signature/api-text.svg"
            alt=""
            width={36.18}
            height={35.26}
            layout="fixed"
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ServiceAnimation2;
